import styles from './Layout.module.css';
import React, { useEffect } from 'react';
import { useLocation, useOutlet } from 'react-router-dom';
import {
    setLocalStorageItem,
    getLocalStorageItem,
    removeLocalStorageItem,
} from 'e3-common/utils/localStorageUtil';
import { LOCAL_STORAGE_KEYS, PAGE_RENDER_TYPE } from 'e3-common/constants/enumerates';
import TopMenu from './TopMenu';
import SideMenu from './SideMenu';
import { useBoundStore } from 'e3-common/store/useBoundStore';
import { useNavigate } from 'react-router-dom';

const Layout = () => {
    const outlet = useOutlet();
    const { pageRenderType } = useBoundStore((state) => state.menu);
    const accessToken = getLocalStorageItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN);

    const location = useLocation();
    const navigate = useNavigate();

    // 현재 경로가 로그인 페이지인지 확인합니다.
    const isLoginPage = location.pathname.includes('/login');

    useEffect(() => {
        if (location) {
            // 도메인입력 + 라우터 경로를 입력했을 때
            if (location.pathname !== '/') {
                // 토큰이 있다면 입력된 라우터 경로로 이동
                if (accessToken) {
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(location.pathname + location.search);
                }
                // 토큰이 없다면
                else {
                    // 로컬 스토리지에 입력된 경로를 저장 후 로그인 페이지로 이동
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME, location.pathname);
                    setLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH, location.search);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
            // 도메인만 입력했을 때
            else {
                // 토큰이 없다면 로그인 페이지로 이동
                if (!accessToken) {
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.PATH_NAME);
                    removeLocalStorageItem(LOCAL_STORAGE_KEYS.SEARCH);
                    navigate(import.meta.env.VITE_PUBLIC_URL + `/login`);
                }
            }
        }
    }, []);

    return (
        <div className={styles.wrap}>
            {/* 토큰이 없거나 로그인 페이지인 경우 메뉴를 숨깁니다. */}
            {!accessToken || isLoginPage ? <></> : <TopMenu />}
            {!accessToken || isLoginPage ? <></> : <SideMenu />}
            <div
                // 로그인 페이지일 경우 loginContents 클래스를 추가하여 height: 100vh 및 grid 확장을 적용합니다.
                className={`${styles.contents} ${isLoginPage ? styles.loginContents : ''}`}
                style={{
                    marginLeft: '0px',
                    // 로그인 페이지가 아닐 때만 기존 조건부 패딩을 유지합니다.
                    ...(!isLoginPage && pageRenderType === PAGE_RENDER_TYPE.PAGE ? { padding: '0px 30px' } : null),
                }}
            >
                {outlet}
            </div>
        </div>

        // <div>
        // <TopMenu />
        // <div className={styles.container}>
        //   <div className={styles.wrap}>
        //     <div className={styles.layout}>
        //       <SideMenu />
        //       <div className={styles.contents} style={{marginLeft:'-35px'}}>{outlet}</div>
        //     </div>
        //   </div>
        // </div>
        // <Footer />
        // </div>
    );
};

Layout.displayName = 'Layout';
export default Layout;
